import React, { useRef } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import { ReactComponent as ExitIcon } from '../../../image/BlackExit.svg';
import { ReactComponent as DownArrowIcon } from '../../../image/DownArrow.svg';

export default function MemberShipInfoBox(props) {
  const {
    data,
    index,
    isClickedMemberShipEdit,
    onClickEditMemberShipButton,
    onClickDeletedMemberShip,
    onClickChangeIndex,
  } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const ExitRef = useRef();

  // 회원권 정보 클릭시 //
  function onClickEditMemberShip(e) {
    if (ExitRef.current && ExitRef.current.contains(e.target)) return;
    onClickEditMemberShipButton(data);
  }

  // 위로이동 버튼 클릭시 //
  function onClickMoveUp(e) {
    e.stopPropagation();
    onClickChangeIndex('UP', index);
  }

  // 아래로이동 버튼 클릭시 //
  function onClickMoveDown(e) {
    e.stopPropagation();
    onClickChangeIndex('DOWN', index);
  }

  return (
    <TopLevelWrapper $isHideAll={data.isHideAll} onClick={onClickEditMemberShip}>
      <TextWrapper>
        <ArrowWrapper>
          <ArrowImageWrapper onClick={onClickMoveUp}>
            <ArrowSvg $rotated />
          </ArrowImageWrapper>
          <ArrowImageWrapper onClick={onClickMoveDown}>
            <ArrowSvg />
          </ArrowImageWrapper>
        </ArrowWrapper>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={data.isHideAll ? theme.bottomText : theme.text} cursor='pointer'>{data.name}</Text>
      </TextWrapper>
      <StatusWrapper>
        { data.isHideAll && <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='pointer'>{t('system.private')}</Text> }
        <ImageWrapper>
          {
            data.autoPayment === 1 &&
            <SubscriptBox>
              <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} cursor='pointer'>{t('settingMembership.subscription')}</Text>
            </SubscriptBox>
          }
          <ExitIconWrapper ref={ExitRef} onClick={() => onClickDeletedMemberShip(data)}>
            <ExitIcon />
          </ExitIconWrapper>
        </ImageWrapper>
      </StatusWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  min-width: 100%;
  height: 30px;

  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const StatusWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 10px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 60%;

  gap: 15px;

  overflow: hidden;
`;

const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 20px;
`;

const SubscriptBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0px 10px;

  border-radius: 5px;
  background-color: ${props => props.theme.primary};
`;

const ExitIconWrapper = styled.div`
  width: 20px;
  height: 20px;

  & svg {
    width: 20px;
    height: 20px;
  }

  & path {
    fill: ${props => props.theme.subText};
  }

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const ArrowWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const ArrowImageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 14px;
  height: 10px;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
    &:hover svg path {
      stroke: ${props => props.theme.primary};
    }
  }
`;

const ArrowSvg = styled(DownArrowIcon)`
  width: 14px;
  height: auto;
  transform: ${props => props.$rotated ? 'rotate(180deg)' : 'none'};
  transition: all 0.3s ease-in-out;

  & path {
    stroke: ${props => props.theme.subText};
  }
`;
